/**
 * Module-level store for subscription read-only mode (read by axios interceptors).
 */

const defaultState = {
  exempt: false,
  readOnly: false,
  endDate: null,
  companyId: null,
};

let state = { ...defaultState };

export const getSubscriptionAccessState = () => state;

export const setSubscriptionAccessState = (partial) => {
  state = { ...state, ...partial };
};

export const resetSubscriptionAccessState = () => {
  state = { ...defaultState };
};
